export default [
  {
    component: () => import("@/components/almoxarifado-02/menu-almoxarifado.vue"),
    name: "almoxarifado",
    path: "/almoxarifado",
    label: "Almoxarifado",
  },
  {
    component: () => import("@/components/almoxarifado-02/menu-produtos-almoxarifado.vue"),
    name: "almoxarifado.produtos",
    path: "/almoxarifado/produtos",
    label: "Produtos",
  },
  {
    component: () => import("@/components/almoxarifado-02/menu-movimentacoes-almoxarifado.vue"),
    name: "almoxarifado.movimentacoes",
    path: "/almoxarifado/movimentacoes",
    label: "Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado-02/menu-relatorios-almoxarifado.vue"),
    name: "almoxarifado.relatorios",
    path: "/almoxarifado/relatorios",
    label: "Relatórios",
  },
  {
    component: () => import("@/components/almoxarifado-02/cadastro-produto-almoxarifado.vue"),
    name: "almoxarifado.produtos.novo",
    path: "/almoxarifado/produtos/novo",
    label: "Cadastrar Produtos",
  },
  {
    component: () => import("@/components/almoxarifado-02/gerenciar-produto-almoxarifado.vue"),
    name: "almoxarifado.produtos.gerenciar",
    path: "/almoxarifado/produtos/gerenciar",
    label: "Visualizar Lista de Produtos",
  },
  {
    component: () => import("@/components/almoxarifado-02/grupos-produtos-almoxarifado.vue"),
    name: "almoxarifado.produtos.grupos",
    path: "/almoxarifado/produtos/grupos",
    label: "Grupos de Produtos",
  },
  {
    component: () => import("@/components/almoxarifado-02/cadastro-movimentacao-almoxarifado.vue"),
    name: "almoxarifado.movimentacoes.novo",
    path: "/almoxarifado/movimentacoes/novo",
    label: "Cadastrar Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado-02/gerenciar-movimentacoes-almoxarifado.vue"),
    name: "almoxarifado.movimentacoes.gerenciar",
    path: "/almoxarifado/movimentacoes/gerenciar",
    label: "Visualizar Lista de Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado-02/cadastro-produto-almoxarifado.vue"),
    name: "almoxarifado.produtos.editar",
    label: "Editar Produtos",
    path: "/almoxarifado/produtos/editar/:id",
  },
  {
    component: () => import("@/components/almoxarifado-02/cadastro-movimentacao-almoxarifado.vue"),
    name: "almoxarifado.movimentacoes.editar",
    path: "/almoxarifado/movimentacoes/editar/:id",
    label: "Editar Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado-02/visualizar-movimentacao-almoxarifado.vue"),
    name: "almoxarifado.movimentacoes.visualizar",
    path: "/almoxarifado/movimentacoes/visualizar/:id",
    label: "Visualizar Detalhes de Movimentações",
  },
  {
    component: () => import("@/components/almoxarifado-02/relatorio-produtos-movimentacoes-almoxarifado.vue"),
    name: "almoxarifado.relatorios.produtos-movimentacoes",
    path: "/almoxarifado/relatorios/produtos-movimentacoes",
    label: "Relatório de Produtos Movimentações",
  },
];
